export const isStudyReadOnly = async (studyLoader, internalStudyId, organizationId) => {
	const rs = await getIsStudyReadOnlyAndPermission(studyLoader, internalStudyId, organizationId);
	return rs.IsLocked && !rs.ModifyLockedStudy;
};

export const getIsStudyReadOnlyAndPermission = async (studyLoader, internalStudyId, organizationId) => {
	console.log('getIsStudyReadOnlyAndPermission', internalStudyId, organizationId);
	const checkPayload = {
		isCheckReadOnly: true,
		organizationId: organizationId,
	};
	const rs = await studyLoader.update(internalStudyId, checkPayload);
	console.log('getIsStudyReadOnlyAndPermission response from API', rs);
	if (rs) {
		return rs;
	} else {
		return {
			IsLocked: false,
			ModifyLockedStudy: false,
		};
	}
};
